module.exports = __webpack_public_path__ + "static/f1_large-eda0cd94ca3a5b52bfd06579f67a6373.jpg";